module.exports = __webpack_public_path__ + "static/mk8-match-32ea190488bdb128cf37a5948fc05096.png";